































import { ITitleBtn } from '@/types'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'TitleBar'
})
export default class extends Vue {
  @Prop()
  private title: any;

  @Prop()
  private titleBtnGroup: any;

  // 是否禁用按钮
  private isDisabled = false;

  // 点击按钮
  private onClick(btn: ITitleBtn) {
    this.isDisabled = true
    setTimeout(() => {
      this.isDisabled = false
    }, 800)
    this.$emit('event', btn.event)
  }
}
